import * as freshchatApi from '@/services/rest-api-vsms/lib/freshchat/freshchat'

let WHOAMI, RESTOREID, STORE, VALIDATION

const exludeFreshchatPath = [
  '/404/',
  '/login/',
  '/forgotpassword/',
  '/forgotpassword/result/',
  '/forgotpassword/reset/',
  '/forgotpassword/verification/',
]
async function getRestoreId(whoami) {
  if (!whoami) return
  try {
    const res = await freshchatApi.get(whoami.userId)
    return res.errors ? null : res.data.restore_id
  } catch (error) {
    console.log(error)
  }
}
function saveRestoreId(userId, restoreId) {
  freshchatApi.store({
    user_id: userId,
    restore_id: restoreId,
  })
}

async function setWidgetMessengerConfig() {
  window.fcWidgetMessengerConfig.externalId = WHOAMI?.email
  window.fcWidgetMessengerConfig.restoreId = RESTOREID
  STORE.dispatch('freshchat/setWidgetMessengerConfig', window.fcWidgetMessengerConfig)
}

function validate(data) {
  return (
    data?.identifier === WHOAMI.email &&
    data?.firstName === WHOAMI.name &&
    data?.lastName === WHOAMI.companyName
  )
}

export async function initFreshchat(whoami, store) {
  let hideChatButton = false
  const freshChatSupportFlag = store.state.identity.featureFlag.find(feature => feature.key == 'freshchat_support')
  if (
    !JSON.parse(freshChatSupportFlag.value).custom_button &&
    JSON.parse(freshChatSupportFlag.value).show
  ) {
    exludeFreshchatPath.forEach((path) => {
      if (path.includes(window.location.pathname) && window.location.pathname !== '/') {
        hideChatButton = true
      }
    })
    window.fcWidgetMessengerConfig.config.headerProperty.hideChatButton = hideChatButton
  }
  if (!whoami || !store.getters['identity/hasAccess'](['0e0-base-livechat:read'])) {
    window.fcWidgetMessengerConfig.config.headerProperty.hideChatButton = true
    return
  }
  WHOAMI = whoami
  RESTOREID = RESTOREID ?? (await getRestoreId(whoami))
  STORE = store

  setWidgetMessengerConfig()

  let timer = setInterval(() => {
    if (window.fcWidget) {
      clearInterval(timer)

      setWidgetMessengerConfig()
      window.fcWidget.setExternalId(whoami.email)
      window.fcWidget.init({
        firstName: whoami.name,
        lastName: whoami.companyName,
        email: whoami.email,
        externalId: whoami.email,
      })

      window.fcWidget.user.get(function (res) {
        VALIDATION = validate(res.data || null)
        let status = res && res.status

        /**condition when mismatched fc user with logged in user,
         * possibly because of data cached*/
        if (status === 200 && !VALIDATION) {
          window.fcWidget.user.clear()
          window.fcWidget.setExternalId(whoami.email)
          initFreshchat(whoami, store)
          return
        }

        /**handle when failed init */
        if (status === 401 && window.fcWidgetMessengerConfig.restoreId !== null) {
          window.fcWidget.setExternalId(whoami.email)
          window.fcWidget.user.setProperties({
            firstName: whoami.name,
            lastName: whoami.companyName,
            email: whoami.email,
          })
          initFreshchat(whoami, store)
          return
        }

        /**prepare data for user creation */
        window.fcWidget.user.setProperties({
          firstName: whoami.name,
          lastName: whoami.companyName,
          email: whoami.email,
        })
        window.fcWidget.on('user:created', function (resp) {
          let createdStatus = resp && resp.status,
            result = resp && resp.data
          window.fcWidget.setExternalId(whoami.email)
          if (createdStatus === 200 && result.restoreId) {
            // Update restoreId in your database
            saveRestoreId(whoami.userId, result.restoreId)
          }
        })
      })
    }
  }, 1000)
}
